export default __webpack_public_path__ + "assets/images/3cac20a7023461f36df5ae49b9b9aa24.png";